<template>
  <div class="metadata-value d-flex flex-column min-w-0">
    <div
      v-for="metadataItem in metadataItems"
      :key="metadataItem.value"
      class="d-flex justify-content-between align-items-start"
    >
      <span class="min-w-0">
        <div
          v-if="Array.isArray(metadataItem.value)"
          class="d-flex flex-column min-w-0"
        >
          <span v-for="item in metadataItem.value" :key="item">
            {{ metadataValue(item) }}
          </span>
        </div>
        <span v-else> {{ metadataValue(metadataItem.value) }}</span>
      </span>
      <b-badge v-if="metadataItems.length > 1" class="metadata-type-badge ml-3">
        {{ metadataItem.type }}
      </b-badge>
    </div>
  </div>
</template>

<script>
import { displayMetadataValue } from '@/utils/metadata';

export default {
  props: {
    metadataItems: {
      type: Array,
      required: true,
    },
  },
  methods: {
    metadataValue: displayMetadataValue,
  },
};
</script>

<style scoped lang="scss">
.metadata-value {
  .metadata-type-badge {
    margin-top: 2px;
  }
}
</style>
